'use client';
import { MainLogo } from '@modules/common/components/logo/main-logo';
import { Facebook } from '@modules/common/icons/facebook';
import { Instagram } from '@modules/common/icons/instagram';
import { LinkedIn } from '@modules/common/icons/linkedIn';
import Link from 'next/link';
import './footer-nav.scss';
import { usePathname } from 'next/navigation';
import { routes } from '@lib/constants/routes-constant';
import { useState, useEffect } from 'react';

type FooterNavProps = {
    variant: 'light' | 'dark';
};

const FooterNav = ({ variant = 'light' }: FooterNavProps) => {
    const pathname = usePathname();
    const [appVersion, setAppVersion] = useState<string>();

    useEffect(() => {
        setAppVersion(localStorage?.getItem('app_version') || '');
    }, []);

    return (
        <div className="footer">
            <div
                className={`footer-content ${variant == 'dark' ? 'footer-dark' : 'footer-light'
                    }`}
            >
                <div className="footerEllipse">
                    <div className="footerEllipse-vector"></div>
                </div>
                <div className="footer-top">
                    <MainLogo
                        className="w-[99px]"
                        variant={variant === 'dark' ? 'light' : 'dark'}
                    />
                </div>
                {(pathname !== routes.temporarily_unavailable) &&
                    <div
                        className={`footerNav ${variant == 'dark' ? 'footerNav-dark' : 'footerNav-light'
                            }`}
                    >
                        <div className="footerNav-item">
                            <Link href="/faqs" prefetch={false}>
                                FAQs
                            </Link>
                        </div>
                        <div className="footerNav-dot"></div>
                        <div className="footerNav-item">
                            <Link href="/contact-us" prefetch={false}>
                                CONTACT US
                            </Link>
                        </div>
                        <div className="footerNav-dot"></div>
                        <div className="footerNav-item">
                            <Link href="/privacy-policy" prefetch={false}>
                                PRIVACY POLICY
                            </Link>
                        </div>
                        <div className="footerNav-dot"></div>
                        <div className="footerNav-item">
                            <Link href="/terms-and-conditions" prefetch={false}>
                                TERMS
                            </Link>
                        </div>
                    </div>
                }
                <div className="socialNetwork">
                    <div className="socialNetwork-item">
                        <a href="https://www.instagram.com/giftcardmarket_/" target='_blank'>
                            <Instagram />
                        </a>
                    </div>
                    <div className="socialNetwork-item">
                        <a href="https://www.facebook.com/profile.php?id=61555658974395&notif_id=1721828713025117&notif_t=page_user_activity&ref=notif" target='_blank'>
                            <Facebook />
                        </a>
                    </div>
                    <div className="socialNetwork-item">
                        <a href="https://www.linkedin.com/company/the-gift-card-market/" target='_blank'>
                            <LinkedIn />
                        </a>
                    </div>
                </div>
                <p className="text-[0.833rem] md:text-sm max-w-[756px] px-4 text-center mx-auto pb-[31px] flex flex-col gap-4">
                    <span>
                        Multiple Patents Pending © 2025 Gift Card Market<sup>TM</sup>, LLC.  All rights reserved.
                    </span>
                    <span>* Our Local Gift Cards are a Prepaid Gift Card product that can be used within a specific category of merchants, i.e., restaurants, spas, or salons.</span>
                    <span>
                        Gift Card Market LLC, is issued by Sunrise Banks N.A.,
                        Member FDIC, pursuant to a license from Mastercard
                        International Incorporated. Mastercard is a registered
                        trademark, and the circles design is a trademark of
                        Mastercard International Incorporated. This card may be
                        used everywhere Debit Mastercard is accepted. Use of
                        this card constitutes acceptance of the terms and
                        conditions stated in the <a href='/policies/Cardholder_Agreement_Giftcardmarket.pdf' className='underline' target="_blank">Cardholder Agreement</a>.
                    </span>
                    <span>
                        Card program marketed and administered by Usio Inc. Usio
                        Inc. is an Independent Sales Organization (ISO) pursuant
                        to an agreement with Sunrise Banks, N.A.<br />
                        <a href='/policies/Sunrise-Banks-Privacy-Notice-Safe-Harbor.pdf' target="_blank" className='underline'>Sunrise Banks Privacy Policy</a>
                    </span>
                </p>
                <p className="text-xs md:text-xs px-4 text-right mx-auto opacity-20">
                    Version: {appVersion}
                </p>
            </div>
        </div>
    );
};

export default FooterNav;
